export const IS_AUTHORIZED_COOKIE_NAME = 'isAuthorized';

